import { Component, OnInit } from '@angular/core';
import { NavbarService } from 'src/app/services/navbar/navbar.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-version',
    templateUrl: './app-version.component.html',
    styleUrls: ['./app-version.component.scss'],
})
export class AppVersionComponent implements OnInit {
    devCounter: number;
    version: string;

    constructor(private navbarService: NavbarService) {
        // get appVersion from environment
        this.version = environment.version;

        this.devCounter = 0;
    }

    ngOnInit() {}

    /**
     * Toggle developer mode after 5 clicks.
     *
     * Increments a counter on each call. On the fifth click,
     * activate developer mode, refreshes the visible dashboards, and resets the counter.
     *
     * @example (click)="toggleDeveloperMode()"
     */
    public toggleDeveloperMode(): void {
        this.devCounter++;
        if (this.devCounter === 5) {
            this.navbarService.toggleDeveloperMode();
            this.devCounter = 0;
        }
    }
}
